import React from "react";
import { bool, func } from "prop-types";
import { Button, Header, Modal } from "semantic-ui-react";
import { FormattedMessage } from "react-intl";

const AdminMessageDialog = ({ showAdminMessage, handleClose }) => {
  return (
    <Modal
      size="small"
      closeOnEscape
      closeOnDimmerClick
      closeIcon
      open={showAdminMessage}
      onClose={() => handleClose()}
    >
      <Header
        icon="attention"
        content={<FormattedMessage id="buyerPortal.sections.caution" />}
      />
      <Modal.Content>
        <FormattedMessage
          id="buyerPortal.sections.onlyAdjustableByBuyer"
          defaultMessage="buyerPortal.sections.onlyAdjustableByBuyer"
        />
      </Modal.Content>
      <Modal.Actions>
        <Button onClick={() => handleClose()}>
          <FormattedMessage
            id="meta.actions.accept"
            defaultMessage="meta.actions.accept"
          />
        </Button>
      </Modal.Actions>
    </Modal>
  );
};

AdminMessageDialog.propTypes = {
  showAdminMessage: bool.isRequired,
  handleClose: func.isRequired
};

export default AdminMessageDialog;
